// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-img-box-list {\n  width: 180px;\n  height: 180px;\n  border: 1px dashed #ccc;\n  border-radius: 20px;\n  text-align: center;\n  line-height: 180px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
